import { format, isToday, isYesterday } from "date-fns";

export const getFormattedDate = (date: Date): string => {
	return isToday(date) ? "Today" : isYesterday(date) ? "Yesterday" : format(date, "d MMM yyyy");
};
